import React from "react";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { US_STATES } from "@/components/shared/StateCheckboxSelector";
import { FUNNEL_OPTIONS } from "@/lib/funnelOptions";
import { SearchSelect } from "./SearchSelect";
import { DateField } from "./DateField";

const STATE_OPTIONS = US_STATES.map((s) => ({ value: s.code, label: `${s.code} · ${s.name}` }));
const PAGE_OPTIONS = FUNNEL_OPTIONS.map((o) => ({ value: o.slug, label: o.title }));

const INPUT = "border-2 border-black px-2 py-1.5 text-xs bg-white w-full";
const RANGES = [7, 30, 90];

function isoDaysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toLocaleDateString("en-CA");
}

export const ResultsFilters = ({ f, set, mediaBuyers, showAdmin }) => {
  const pickRange = (n) => set({ date_from: isoDaysAgo(n - 1), date_to: isoDaysAgo(0) });
  const anyFilter = f.q || f.state || f.page || f.source || f.outcome || f.media_buyer_id;
  return (
    <section className="brut-card bg-white p-3 mb-6 flex flex-col gap-3" data-testid="results-filters">
      <div className="flex flex-wrap items-center gap-2">
        {RANGES.map((n) => (
          <button key={n} type="button" onClick={() => pickRange(n)} data-testid={`results-range-${n}`}
                  className="border-2 border-black px-2.5 py-1 text-[10px] uppercase tracking-widest bg-white hover:bg-black hover:text-white">
            Last {n} days
          </button>
        ))}
        <DateField label="From" value={f.date_from} onChange={(v) => set({ date_from: v })} testId="results-date-from" />
        <DateField label="To" value={f.date_to} onChange={(v) => set({ date_to: v })} testId="results-date-to" />
        <label className="text-[10px] uppercase tracking-widest flex items-center gap-1 ml-auto">
          <input type="checkbox" checked={f.include_test} onChange={(e) => set({ include_test: e.target.checked })} data-testid="results-include-test" /> Include test leads
        </label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
        <div className="relative md:col-span-2">
          <MagnifyingGlass size={13} className="absolute left-2 top-2.5" />
          <input className={`${INPUT} pl-7`} placeholder={showAdmin ? "Search reference, firm, media buyer, source, status…" : "Search reference, firm, source, status…"}
                 value={f.q} onChange={(e) => set({ q: e.target.value })} data-testid="results-search" />
        </div>
        <SearchSelect value={f.state} onChange={(v) => set({ state: v })} options={STATE_OPTIONS}
                      allLabel="All states" placeholder="Search states…" testId="results-state" />
        <SearchSelect value={f.page} onChange={(v) => set({ page: v })} allLabel="All landing pages" placeholder="Search landing pages…"
                      options={f.page && !PAGE_OPTIONS.some((o) => o.value === f.page) ? [...PAGE_OPTIONS, { value: f.page, label: f.page }] : PAGE_OPTIONS}
                      testId="results-page" />
        <input className={INPUT} placeholder="Traffic source (sub id)" value={f.source} onChange={(e) => set({ source: e.target.value })} data-testid="results-source" />
      </div>
      {(showAdmin || anyFilter) && (
        <div className="flex flex-wrap items-center gap-2">
          {showAdmin && (
            <div className="w-72 max-w-full">
              <SearchSelect value={f.media_buyer_id} onChange={(v) => set({ media_buyer_id: v })}
                            options={mediaBuyers.map((m) => ({ value: m.id, label: `${m.name} · ${m.tracking_code}` }))}
                            allLabel="All media buyers" placeholder="Search name or tracking code…" testId="results-media-buyer" />
            </div>
          )}
          {anyFilter && (
            <button type="button" onClick={() => set({ q: "", state: "", page: "", source: "", outcome: "", media_buyer_id: "" })}
                    className="text-[10px] uppercase tracking-widest underline inline-flex items-center gap-1" data-testid="results-clear">
              <X size={10} weight="bold" /> Clear filters
            </button>
          )}
        </div>
      )}
    </section>
  );
};
